<page-wrap  [headline]="course?.course?.title ?? ('Промяна на страница' | transloco)"
            [subheading]="franchiseId && (user | roleAny:'admin') ? (franchise?.name ?? '') : ''"
            [navigation]="
                (user | roleAny:'admin':'marketing') ? [
                    {
                        title: 'Партньори' | transloco,
                        link: '/partners'
                    }, {
                        title: franchise?.name ?? '',
                        link: '/partners/' + franchiseId
                    }, {
                        title: course?.course?.title ?? '',
                        link: ('/partners/' + franchiseId + '/courses/' + courseId)
                    }, {
                        title: ('Редакция на закупен курс' | transloco)
                    }
                ] : [
                    {
                        title: 'Компания' | transloco,
                        link: '/company'
                    }, {
                        title: 'Закупени курсове' | transloco,
                        link: '/courses/list'
                    }, {
                        title: course?.course?.title ?? '',
                        link: '/courses/' + courseId
                    }, {
                        title: ('Редакция на закупен курс' | transloco)
                    }
                ]"
>
    <ng-container *ngIf="false">
        {{ 'Закупен курс \{{course}\}'|transloco:{course:course?.course?.title} }}
        {{ 'Закупен курс'|transloco }}
        {{ 'Преглед на закупен курс'|transloco }}
        {{ 'Редакция на закупен курс'|transloco }}
    </ng-container>

    <ng-template section="sidebar"></ng-template>

        <form class="standard-form d-flex flex-column" [formGroup]="form" (submit)="onSubmit($event)" *ngIf="form">

            <div class="card mb-3 mb-lg-5">
                <div class="card-header d-flex justify-content-between align-items-center">
                    <h3 class="my-0 fw-bold">{{'Курс' | transloco}}</h3>
                    <div class="form-check form-switch d-inline-block">
                        <input class="form-check-input" type="checkbox" id="statusToggle" formControlName="status">
                        <label class="form-check-label" for="statusToggle">{{ form?.get('status')?.value ? ('Активен'|transloco) : ('Неактивен'|transloco) }}</label>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-7 col-lg-8" [ngClass]="{'col-md-12 col-lg-12': user && !(user | roleAny:'admin')}">
                            <div class="row mb-4">
                                <label for="url" class="col-12">{{ 'Приятелски URL:' | transloco }}</label>
                                <div class="col-12">
                                    <input  requiredField requiredFieldAttribute="url"
                                            type="text"
                                            id="url"
                                            class="form-control"
                                            name="url"
                                            placeholder="programming-course-java-basics"
                                            formControlName="url"
                                            [attr.disabled]="loading ? true : null"
                                            [class.is-invalid]="errors?.url?.status === 'INVALID'"
                                    />
                                    <div class="invalid-feedback" *ngIf="errors?.url?.errors?.pattern">{{ 'Невалидни символи' | transloco }}</div>
                                    <div class="invalid-feedback" *ngIf="errors?.url?.errors?.required">{{ 'Задължително поле' | transloco }}</div>
                                    <div class="invalid-feedback" *ngIf="errors?.url?.errors?.maxlength">{{ 'Не може да е повече от 255 символа' | transloco }}</div>
                                    <div class="invalid-feedback" *ngIf="errors?.url?.errors?.notunique">{{ 'Полето не съдържа уникален адрес' | transloco }}</div>
                                    <div class="invalid-feedback" *ngIf="errors?.url?.errors?.any">{{ errors?.url?.errors?.any }}</div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-5 col-lg-4" *ngIf="user && (user | roleAny:'admin')">
                            <div class="row mb-4" >
                                <label for="design" class="col-12">{{ 'Дизайн:' | transloco }}</label>
                                <div class="col-12">
                                    <p-dropdown requiredField requiredFieldAttribute="design"
                                                inputId="design"
                                                [class.is-invalid]="errors?.design?.status === 'INVALID'"
                                                [filter]="false"
                                                [options]="optionsDesign"
                                                formControlName="design"
                                                optionValue="id"
                                                optionLabel="title"
                                                styleClass="w-100"
                                    ></p-dropdown>
                                    <div class="invalid-feedback" *ngIf="errors?.design?.errors?.required">{{ 'Задължително поле' | transloco }}</div>
                                    <div class="invalid-feedback" *ngIf="errors?.design?.errors?.any">{{ errors?.design?.errors?.any }}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <div class="row mb-4">
                                <label for="meta_title" class="col-12">{{ 'Заглавие на страницата и Meta заглавие:' | transloco }}</label>
                                <div class="col-12">
                                    <input  requiredField requiredFieldAttribute="meta_title"
                                            type="text"
                                            id="meta_title"
                                            class="form-control"
                                            [placeholder]="'Мета заглавие' | transloco "
                                            formControlName="title"
                                            [attr.disabled]="loading ? true : null"
                                            [class.is-invalid]="errors?.title?.status === 'INVALID'"
                                    />
                                    <div class="invalid-feedback" *ngIf="errors?.title?.errors?.pattern">{{ 'Невалидни символи' | transloco }}</div>
                                    <div class="invalid-feedback" *ngIf="errors?.title?.errors?.required">{{ 'Задължително поле' | transloco }}</div>
                                    <div class="invalid-feedback" *ngIf="errors?.title?.errors?.maxlength">{{ 'Не може да е повече от 255 символа' | transloco }}</div>
                                    <div class="invalid-feedback" *ngIf="errors?.title?.errors?.notunique">{{ 'Полето не съдържа уникален адрес' | transloco }}</div>
                                    <div class="invalid-feedback" *ngIf="errors?.title?.errors?.any">{{ errors?.title?.errors?.any }}</div>
                                </div>
                            </div>

                            <div class="col-12 mb-4">
                                <div class="row">
                                    <label for="meta_description" class="col-12">{{ 'Meta описание' | transloco }}<small
                                        *ngIf="form?.controls?.['description']?.value?.length"
                                        > ({{ form?.controls?.['description']?.value?.length }})</small>:
                                    </label>
                                    <div class="col-12">
                                        <textarea   requiredField requiredFieldAttribute="meta_description"
                                                    type="text"
                                                    id="meta_description"
                                                    class="form-control"
                                                    rows="4"
                                                    [placeholder]="'Meta описание' | transloco "
                                                    formControlName="description"
                                                    [attr.disabled]="loading ? true : null"
                                                    [class.is-invalid]="errors?.description?.status === 'INVALID'"
                                        ></textarea>
                                        <div class="invalid-feedback" *ngIf="errors?.description?.errors?.required">{{ 'Задължително поле' | transloco }}</div>
                                        <div class="invalid-feedback" *ngIf="errors?.description?.errors?.maxlength">{{ 'Не може да е повече от 255 символа' | transloco }}</div>
                                        <div class="invalid-feedback" *ngIf="errors?.description?.errors?.any">{{ errors?.meta_description?.errors?.any }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-auto mb-2">
                            <div class="row"><label class="col-12 mb-2">{{ 'Основно изображение:' | transloco }}</label></div>
                            <upload-image (onFinished)="onImageFinished($event)"
                                            (onRemove)="image = {};"
                                            [withRemove]="true"
                                            [labelDefault]="'Снимка, 3:2' | transloco"
                                            [loading]="loading"
                                            [class.is-invalid]="errors?.image?.status === 'INVALID'"
                                            [preview]="image?.url ?? ''"
                            ></upload-image>

                            <div class="invalid-feedback" *ngIf="errors?.image?.errors?.required">{{ 'Задължително поле' | transloco }}</div>
                            <div class="invalid-feedback" *ngIf="errors?.image?.errors?.maxlength">{{ 'Не може да е повече от 255 символа' | transloco }}</div>
                            <div class="invalid-feedback" *ngIf="errors?.image?.errors?.any">{{ errors?.image?.errors?.any }}</div>
                        </div>
                        <div class="col-auto mb-2">
                            <div class="row"><label class="col-12 mb-2">{{ 'Снимка за споделяне:' | transloco }}</label></div>
                            <upload-image (onFinished)="onImageShareFinished($event)"
                                            (onRemove)="imageShare = {};"
                                            [withRemove]="true"
                                            [labelDefault]="'Снимка, 1200x630px' | transloco"
                                            [loading]="loading"
                                            [class.is-invalid]="errors?.image_share?.status === 'INVALID'"
                                            [preview]="imageShare?.url ?? ''"
                            ></upload-image>

                            <div class="invalid-feedback" *ngIf="errors?.image_share?.errors?.required">{{ 'Задължително поле' | transloco }}</div>
                            <div class="invalid-feedback" *ngIf="errors?.image_share?.errors?.maxlength">{{ 'Не може да е повече от 255 символа' | transloco }}</div>
                            <div class="invalid-feedback" *ngIf="errors?.image_share?.errors?.any">{{ errors?.image_share?.errors?.any }}</div>
                        </div>
                    </div>
                </div>
                <div class="card-header" [class.d-none]="!franchise?.primary">
                    <h3 class="my-0 fw-bold">{{ 'Публична страница на курса' | transloco }}</h3>
                </div>
                <div class="card-body" [class.d-none]="!franchise?.primary">
                    <div class="row">
                        <div class="col-6 mb-3">
                            <label for="landing_course_category">{{ 'Замени категория' | transloco }}:</label>

                            <p-dropdown requiredField requiredFieldAttribute="landing_course_category"
                                        inputId="landing_course_category"
                                        [class.is-invalid]="errors?.landing_course_category?.status === 'INVALID'"
                                        [filter]="false"
                                        [options]="optionsCategory"
                                        formControlName="landing_course_category"
                                        optionValue="value"
                                        optionLabel="label"
                                        styleClass="w-100"
                            ></p-dropdown>

                            <div class="invalid-feedback" *ngIf="errors?.landing_course_category?.errors?.required">{{ 'Задължително поле' | transloco }}</div>
                            <div class="invalid-feedback" *ngIf="errors?.landing_course_category?.errors?.minlength && !errors?.landing_course_category?.errors?.required">{{ 'Полето не може да е по-кратко от 2 символа' | transloco }}</div>
                            <div class="invalid-feedback" *ngIf="errors?.landing_course_category?.errors?.maxlength">{{ 'Полето надвишава 255 символа' | transloco }}</div>
                            <div class="invalid-feedback" *ngIf="errors?.landing_course_category?.errors?.any">{{ errors?.landing_course_category?.errors?.any }}</div>
                        </div>

                        <div class="col-6 mb-3">
                            <label for="landing_course_viber">{{ 'Viber група за курсисти' | transloco }}:</label>

                            <input  requiredField requiredFieldAttribute="landing_course_viber"
                                    type="text"
                                    id="landing_course_viber"
                                    class="form-control"
                                    [placeholder]="'Viber URL покана' | transloco "
                                    formControlName="landing_course_viber"
                                    [attr.disabled]="loading ? true : null"
                                    [class.is-invalid]="errors?.landing_course_viber?.status === 'INVALID'"
                            />

                            <div class="invalid-feedback" *ngIf="errors?.landing_course_viber?.errors?.required">{{ 'Задължително поле' | transloco }}</div>
                            <div class="invalid-feedback" *ngIf="errors?.landing_course_viber?.errors?.minlength && !errors?.landing_course_viber?.errors?.required">{{ 'Полето не може да е по-кратко от 2 символа' | transloco }}</div>
                            <div class="invalid-feedback" *ngIf="errors?.landing_course_viber?.errors?.maxlength">{{ 'Полето надвишава 255 символа' | transloco }}</div>
                            <div class="invalid-feedback" *ngIf="errors?.landing_course_viber?.errors?.any">{{ errors?.landing_course_viber?.errors?.any }}</div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <label for="landing_course_scripts">{{ 'Код за проследяване' | transloco }}:</label>

                             <textarea   requiredField requiredFieldAttribute="landing_course_scripts"
                                        type="text"
                                        id="landing_course_scripts"
                                        class="form-control"
                                        rows="4"
                                        [placeholder]="'Pixel, Analytics или др.' | transloco "
                                        formControlName="landing_course_scripts"
                                        [attr.disabled]="loading ? true : null"
                                        [class.is-invalid]="errors?.landing_course_scripts?.invalid"
                            ></textarea>

                            <div class="invalid-feedback" *ngIf="errors?.landing_course_scripts?.errors?.required">{{ 'Задължително поле' | transloco }}</div>
                            <div class="invalid-feedback" *ngIf="errors?.landing_course_scripts?.errors?.minlength && !errors?.landing_course_scripts?.errors?.required">{{ 'Полето не може да е по-кратко от 2 символа' | transloco }}</div>
                            <div class="invalid-feedback" *ngIf="errors?.landing_course_scripts?.errors?.maxlength">{{ 'Полето надвишава 65535 символа' | transloco }}</div>
                            <div class="invalid-feedback" *ngIf="errors?.landing_course_scripts?.errors?.any">{{ errors?.landing_course_scripts?.errors?.any }}</div>
                        </div>
                    </div>
                </div>

                <div class="card-header" [class.d-none]="!franchise?.primary">
                    <h3 class="my-0 fw-bold">{{ 'Публична страница на курса - Страничен панел' | transloco }}</h3>
                </div>
                <div class="card-body" [class.d-none]="!franchise?.primary">
                    <div class="row">
                        <div class="col-6 mb-3">
                            <div class="row"><label for="options" class="col-12">{{ 'Характеристики:' | transloco }}</label></div>

                            <p-multiSelect requiredField requiredFieldAttribute="sidebar_options"
                                            id="sidebar_options"
                                            class="w-100"
                                            [options]="optionsSidebar"
                                            [group]="true"
                                            optionValue="value"
                                            optionLabel="label"
                                            [placeholder]="'Изберете характеристики на курса' | transloco"
                                            display="chip"
                                            [maxSelectedLabels]="10"
                                            [selectedItemsLabel]="'Избрани елементи: {0}' | transloco"
                                            formControlName="sidebar_options"
                                            [class.is-invalid]="errors?.options?.status === 'INVALID'"
                            ></p-multiSelect>

                            <div class="invalid-feedback" *ngIf="errors?.options?.errors?.required">{{ 'Задължително поле' | transloco }}</div>
                            <div class="invalid-feedback" *ngIf="errors?.options?.errors?.maxlength">{{ 'Не може да е повече от 255 символа' | transloco }}</div>
                            <div class="invalid-feedback" *ngIf="errors?.spotlights?.errors?.any">{{ errors?.spotlights?.errors?.any }}</div>
                        </div>

                        <div class="col-6 mb-3">
                            <label for="landing_course_suitable">{{ 'Курсът е подходящ за' | transloco }}:</label>

                            <input  requiredField requiredFieldAttribute="landing_course_suitable"
                                    type="text"
                                    id="landing_course_suitable"
                                    class="form-control"
                                    [placeholder]="'Напр. за 1-4 клас' | transloco "
                                    formControlName="landing_course_suitable"
                                    [attr.disabled]="loading ? true : null"
                                    [class.is-invalid]="errors?.landing_course_suitable?.status === 'INVALID'"
                            />

                            <div class="invalid-feedback" *ngIf="errors?.landing_course_suitable?.errors?.required">{{ 'Задължително поле' | transloco }}</div>
                            <div class="invalid-feedback" *ngIf="errors?.landing_course_suitable?.errors?.minlength && !errors?.landing_course_suitable?.errors?.required">{{ 'Полето не може да е по-кратко от 2 символа' | transloco }}</div>
                            <div class="invalid-feedback" *ngIf="errors?.landing_course_suitable?.errors?.maxlength">{{ 'Полето надвишава 255 символа' | transloco }}</div>
                            <div class="invalid-feedback" *ngIf="errors?.landing_course_suitable?.errors?.any">{{ errors?.landing_course_suitable?.errors?.any }}</div>
                        </div>

                        <div class="col-12 mb-3">
                            <label for="landing_course_videoclip">{{ 'Видео клип' | transloco }}:</label>

                            <text-editor
                                            requiredField requiredFieldAttribute="landing_course_videoclip"
                                            formControlName="landing_course_videoclip"
                                            class="d-block is-invalid"
                                            [class.is-invalid]="form.controls['landing_course_videoclip'].invalid && form.controls['landing_course_videoclip'].touched"
                            ></text-editor>

                            <div class="invalid-feedback" *ngIf="errors?.landing_course_videoclip?.errors?.required">{{ 'Задължително поле' | transloco }}</div>
                            <div class="invalid-feedback" *ngIf="errors?.landing_course_videoclip?.errors?.minlength && !errors?.landing_course_videoclip?.errors?.required">{{ 'Полето не може да е по-кратко от 2 символа' | transloco }}</div>
                            <div class="invalid-feedback" *ngIf="errors?.landing_course_videoclip?.errors?.maxlength">{{ 'Полето надвишава 65535 символа' | transloco }}</div>
                            <div class="invalid-feedback" *ngIf="errors?.landing_course_videoclip?.errors?.any">{{ errors?.landing_course_videoclip?.errors?.any }}</div>
                        </div>

                        <div class="col-12 mb-3">
                            <label for="landing_course_additional_text">{{ 'Допълнителен текст' | transloco }}:</label>

                            <text-editor
                                            requiredField requiredFieldAttribute="landing_course_additional_text"
                                            formControlName="landing_course_additional_text"
                                            class="d-block is-invalid"
                                            [class.is-invalid]="form.controls['landing_course_additional_text'].invalid && form.controls['landing_course_additional_text'].touched"
                            ></text-editor>

                            <div class="invalid-feedback" *ngIf="errors?.landing_course_additional_text?.errors?.required">{{ 'Задължително поле' | transloco }}</div>
                            <div class="invalid-feedback" *ngIf="errors?.landing_course_additional_text?.errors?.minlength && !errors?.landing_course_additional_text?.errors?.required">{{ 'Полето не може да е по-кратко от 2 символа' | transloco }}</div>
                            <div class="invalid-feedback" *ngIf="errors?.landing_course_additional_text?.errors?.maxlength">{{ 'Полето надвишава 65535 символа' | transloco }}</div>
                            <div class="invalid-feedback" *ngIf="errors?.landing_course_additional_text?.errors?.any">{{ errors?.landing_course_additional_text?.errors?.any }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card d-flex mb-5">
                <div class="card-header d-flex justify-content-between align-items-center">
                    <h3 class="my-0 fw-bold me-auto">{{'Секции' | transloco}}</h3>

                    <menu-actions [actions]="[
                                    { text: ('Добави' | transloco), icon: 'fa-solid fa-plus fa-fw', id: 'add' },
                                    { text: ('Копирай от курс' | transloco), icon: 'fa-regular fa-copy fa-fw', id: 'copy' },
                                    {
                                        id: 'import',
                                        text: ('Импорт' | transloco),
                                        icon: 'fa-solid fa-file-import fa-fw',
                                        file: 'reader',
                                    },
                                    { text: ('Експорт' | transloco), id: 'export', icon: 'fa-solid fa-file-export fa-fw' },
                                ]"
                                [rightOffset]="false"
                                [roles]="['admin','partner']"
                                (buttonClicked)="onSectionAction($event)"
                                (onFileEvent)="importFromJson($event)"
                    ></menu-actions>

                </div>
                <div class="card-body" formArrayName="sections">
                    <div cdkDropList class="section-list" (cdkDropListDropped)="drop($event)">
                        <div    *ngFor="let section of sectionControls.controls; let i = index"
                                class="section-select d-flex justify-content-between align-items-center"
                                cdkDrag
                                (click)="selectSection(i)"
                                [ngClass]="{'selected-section': i === selectedSectionIndex}"
                        >
                            <h2 class="m-0">
                                <div class="row g-2">
                                    <div class="col-auto d-flex align-items-center jusitfy-content-center" *ngIf="!section.get('status')?.value" >
                                        <i class="fa-solid fa-eye-slash fa-fw text-warning"></i>
                                    </div>
                                    <div class="col" [class.text-decoration-line-through]="!section.get('status')?.value">
                                        {{ section.get('title')?.value || (SECTION_NAMES[section.get('type')?.value ?? ''] || ('Секция' | transloco)) }}

                                        <div class="small text-capitalize">{{ section.get('type')?.value ?? ('Секция' | transloco) }}</div>
                                    </div>
                                </div>
                            </h2>
                            <span class="py-0 px-2 me-3" (click)="removeSection($event, i)" [title]="'Премахване' | transloco"><i class="fa-solid fa-fw fa-trash-can text-danger"></i></span>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="selectedSectionIndex !== null && form.get('selectedSection')" class="card mb-3 mb-lg-5" >
                <div [formGroup]="selectedSectionFormGroup">
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <h3 class="my-0 fw-bold">{{ ('Детайли на секция' | transloco) }}</h3>
                        <div class="form-check form-switch d-inline-block">
                            <input class="form-check-input" type="checkbox" id="sectionStatusToggle{{ selectedSectionIndex }}" formControlName="status">
                            <label class="form-check-label" for="sectionStatusToggle{{ selectedSectionIndex }}">{{ selectedSectionFormGroup.get('status')?.value ? ('Активен'|transloco) : ('Неактивен'|transloco) }}</label>
                        </div>
                    </div>
                    <div class="card-body" >
                        <div class="row">
                            <div class="col-12 col-lg-7 col-xl-8">
                                <div class="row">
                                    <div class="col-12 mb-2">
                                        <label for="type">{{ 'Тип' | transloco }}</label>
                                        <p-dropdown [options]="sectionTypeOptions"
                                                    optionLabel="label"
                                                    optionValue="value"
                                                    [filter]="true"
                                                    formControlName="type"
                                                    styleClass="w-100"
                                        >
                                            <ng-template let-item pTemplate="item">
                                                <div>
                                                    {{ item?.label ?? '' }}
                                                    <small class="d-block">{{ item?.type ?? '' }}</small>
                                                </div>
                                            </ng-template>
                                        </p-dropdown>
                                    </div>
                                    <div class="col-12 mb-2">
                                        <label for="title">{{ 'Заглавие' | transloco }}</label>
                                        <input
                                                type="text"
                                                class="form-control"
                                                formControlName="title"
                                                [class.is-invalid]="selectedSectionFormGroup?.controls?.['title']?.status === 'INVALID'">

                                        <div class="invalid-feedback" *ngIf="selectedSectionFormGroup?.controls?.['title']?.errors?.['maxlength']">{{ 'Не може да е повече от 255 символа' | transloco }}</div>
                                    </div>
                                    <div class="col-12 mb-2">
                                        <label for="subtitle">{{ 'Подзаглавие' | transloco }}</label>
                                        <input  type="text"
                                                class="form-control"
                                                formControlName="subtitle"
                                                [class.is-invalid]="selectedSectionFormGroup?.controls?.['subtitle']?.status === 'INVALID'">
                                        <div class="invalid-feedback" *ngIf="selectedSectionFormGroup?.controls?.['subtitle']?.errors?.['maxlength']">{{ 'Не може да е повече от 255 символа' | transloco }}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-lg-5 col-xl-4">
                                <div class="row">
                                    <div class="col-12 mb-2">
                                        <label class="d-block mb-2">{{ 'Снимка' | transloco }}</label>
                                        <upload-image   (onFinished)="onFileFinished($event, false, selectedSectionIndex)"
                                                        (onRemove)="removeFile(false, selectedSectionIndex)"
                                                        [preview]="getPhotoUrl(false, selectedSectionIndex)"
                                                        [withRemove]="true"
                                                        [loading]="loading"
                                                        [class.is-invalid]="selectedSectionFormGroup?.controls?.['image']?.status === 'INVALID'">
                                        </upload-image>
                                        <div class="invalid-feedback" *ngIf="selectedSectionFormGroup?.controls?.['image']?.errors?.['maxlength']">{{ 'Не може да е повече от 255 символа' | transloco }}</div>
                                    </div>
                                    <div class="col-12 mb-2">
                                        <label for="alt">{{ 'Алтернативен текст' | transloco }}</label>
                                        <input  type="text"
                                                class="form-control"
                                                formControlName="alt"
                                                [class.is-invalid]="selectedSectionFormGroup?.controls?.['alt']?.status === 'INVALID'">
                                        <div class="invalid-feedback" *ngIf="selectedSectionFormGroup?.controls?.['alt']?.errors?.['maxlength']">{{ 'Не може да е повече от 255 символа' | transloco }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <label for="itemDescription" class="col-12">{{ 'Съдържание:' | transloco }}</label>
                            <div class="col-12">
                                <text-editor type="text"
                                            id="itemDescription"
                                            name="description"
                                            formControlName="description"
                                            [attr.disabled]="loading ? true : null"
                                            [class.is-invalid]="selectedSectionFormGroup?.controls?.['description']?.status === 'INVALID'"
                                ></text-editor>
                                <div class="invalid-feedback" *ngIf="selectedSectionFormGroup?.controls?.['description']?.errors?.['maxlength']">{{ 'Не може да е повече от 65535 символа' | transloco }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="selectedSectionIndex !== null" class="card mb-3 mb-lg-5">
                <div class="card-header d-flex justify-content-between align-items-center">
                    <h3 class="my-0 fw-bold">{{('Елементи на Секция' | transloco) }}</h3>
                    <button type="button" class="btn btn-primary btn-sm" (click)="addItem()" *ngIf="canAddItems">
                        <i class="fa-solid fa-plus fa-fw"></i> {{'Добави' | transloco}}
                    </button>
                </div>
                <div class="card-body p-0">
                    <div class="alert alert-warning m-2" *ngIf="!canAddItems">
                        <p class="mb-0">{{'Към този тип секция не могат да бъдат добавени елементи.' | transloco}}</p>
                    </div>
                    <div cdkDropList class="accordion accordion-flush" id="accordionFlushExample" (cdkDropListDropped)="dropItem($event)">
                        <div *ngFor="let item of selectedSectionItems.controls; let j = index" [cdkDragDisabled]="isItemsAccordionLocked" cdkDrag class="accordion-item" [formGroup]="getFormGroupAtIndex(j)">
                            <h2 class="accordion-header d-flex justify-content-between" [id]="'heading' + j">
                                <button class="accordion-button collapsed" (click)="toggleAccordionState(j)" type="button" data-bs-toggle="collapse" [attr.data-bs-target]="'#collapse' + j" aria-expanded="true" [attr.aria-controls]="'collapse' + j">
                                    {{ ('Елемент' | transloco) + ' ' + (j + 1) }}
                                </button>
                                <div class="d-flex align-items-center">
                                    <div class="form-check form-switch fs-6 pt-3 me-4">
                                        <input class="form-check-input mt-2" type="checkbox" [id]="'itemStatusToggle' + j" formControlName="status" [checked]="item.get('status')?.value">
                                        <label class="form-check-label" [for]="'itemStatusToggle' + j">
                                            {{ item.get('status')?.value ? ('Активен' | transloco) : ('Неактивен' | transloco) }}
                                        </label>
                                    </div>
                                    <span class="py-0 px-2 mt-3 me-3" (click)="removeItem(j)" [title]="'Премахване' | transloco"><i class="fa-solid fa-fw fa-trash-can text-danger"></i></span>
                                </div>
                            </h2>
                            <div [id]="'collapse' + j" class="accordion-collapse collapse" [attr.aria-labelledby]="'heading' + j" data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    <div class="row">
                                        <div class="col-12 col-lg-7 col-xl-8">
                                            <div class="row">
                                                <div class="col-12 mb-2">
                                                    <label>{{'Заглавие' | transloco}}</label>
                                                    <input  type="text"
                                                            class="form-control"
                                                            formControlName="title"
                                                            [class.is-invalid]="item?.get('title')?.status === 'INVALID'">
                                                    <div class="invalid-feedback" *ngIf="item?.get('title')?.errors?.['maxlength']">{{ 'Не може да е повече от 255 символа' | transloco }}</div>
                                                </div>
                                                <div class="col-12 mb-2">
                                                    <label>{{'Подзаглавие' | transloco}}</label>
                                                    <input type="text" class="form-control" formControlName="subtitle" [class.is-invalid]="item?.get('subtitle')?.status === 'INVALID'">
                                                    <div class="invalid-feedback" *ngIf="item?.get('subtitle')?.errors?.['maxlength']">{{ 'Не може да е повече от 255 символа' | transloco }}</div>
                                                </div>
                                                <div class="col-12 mb-2">
                                                    <label>{{'URL' | transloco}}</label>
                                                    <input type="text" class="form-control" formControlName="url" [class.is-invalid]="item?.get('url')?.status === 'INVALID'">
                                                    <div class="invalid-feedback" *ngIf="item?.get('url')?.errors?.['maxlength']">{{ 'Не може да е повече от 255 символа' | transloco }}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-lg-5 col-xl-4">
                                            <div class="row">
                                                <div class="col-12 mb-2">
                                                    <label class="d-block mb-2">{{ 'Снимка' | transloco }}</label>
                                                    <upload-image   (onFinished)="onFileFinished($event, false, selectedSectionIndex, j)"
                                                                    (onRemove)="removeFile(false, selectedSectionIndex, j)"
                                                                    [preview]="getPhotoUrl(false, selectedSectionIndex, j)"
                                                                    [loading]="loading"
                                                                    [class.is-invalid]="item?.get('image')?.status === 'INVALID'">
                                                    </upload-image>
                                                    <div class="invalid-feedback" *ngIf="item?.get('image')?.errors?.['maxlength']">{{ 'Не може да е повече от 255 символа' | transloco }}</div>
                                                </div>

                                                <div class="col-12 mb-2">
                                                    <label>{{'Алтернативен текст' | transloco}}</label>
                                                    <input type="text" class="form-control" formControlName="alt" [class.is-invalid]="item?.get('alt')?.status === 'INVALID'">
                                                    <div class="invalid-feedback" *ngIf="item?.get('alt')?.errors?.['maxlength']">{{ 'Не може да е повече от 255 символа' | transloco }}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <label for="description" class="col-12">{{ 'Съдържание:' | transloco }}</label>

                                        <text-editor type="text"
                                                        id="description"
                                                        name="description"
                                                        formControlName="description"
                                                        [attr.disabled]="loading ? true : null"
                                                        [class.is-invalid]="item?.get('description')?.status === 'INVALID'"
                                        ></text-editor>
                                        <div class="invalid-feedback" *ngIf="item?.get('description')?.errors?.['maxlength']">{{ 'Не може да е повече от 65535 символа' | transloco }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="submit-panel bg-white py-2 mb-5 text-center">
                <button type="button"
                        class="btn btn-primary"
                        [disabled]="loading || (form?.get('payments')?.value?.length === 0)"
                        (click)="onSubmit($event)"
                >
                    <i *ngIf="loading" class="fa-solid fa-spinner fa-fw fa-pulse"></i>
                    <i *ngIf="!loading" class="fa-solid fa-check fa-fw"></i>

                    <span class="mx-2">{{ 'Запиши' | transloco }}</span>
                </button>
            </div>
        </form>
</page-wrap>

<modal-items-chooser *ngIf="showCopySectionsDialog"
                     [headline]="'Изберете курсове със секции' | transloco"
                     [items]="franchiseCoursesList"
                     (onSelect)="onSelectSectionsToCopy($event)"
                     (onAction)="showCopySectionsDialog = false"
                     (onMoreItems)="onFranchiseCourseListMore($event)"
></modal-items-chooser>
